import { render, staticRenderFns } from "./StopSafariCom.vue?vue&type=template&id=31060674&scoped=true&"
import script from "./StopSafariCom.vue?vue&type=script&lang=js&"
export * from "./StopSafariCom.vue?vue&type=script&lang=js&"
import style0 from "./StopSafariCom.vue?vue&type=style&index=0&id=31060674&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31060674",
  null
  
)

export default component.exports